import type { CLAIMSSTATEINTERFACE } from '@fitness-force/models';
import { createAction, props } from '@ngrx/store';

export const SET_CLAIMS_DETAILS =  createAction(
    'SETCLAIMSDETAILS',
    props<{ claims: CLAIMSSTATEINTERFACE }>()
);